import { UPDATE_BUSINESS_CHATROOM_ID } from '../actions';

export function businessChatRoomId(state = '', action) {
  switch (action.type) {
    case UPDATE_BUSINESS_CHATROOM_ID: {
      return action.chatRoomId;
    }
    default:
      return state;
  }
}
